import { MmsService } from "interfaces/mms-service"
import { CommunicationService } from "services/mms/mock/CommunicationService"
import { MockCardHolderService } from "./entities-services/CardHolderMockService.ts"
import { MockInvoiceService } from "services/mms/mock/entities-services/InvoicesMockService"
import { MockProfileService } from "services/mms/mock/entities-services/ProfileMockService"
import { MockRfidService } from "services/mms/mock/entities-services/RfidMockService"
import { MockSessionsService } from "services/mms/mock/entities-services/SessionsMockService"
import { MockStationsService } from "services/mms/mock/entities-services/StationsMockService"
import { MockPaymentService } from "services/mms/mock/entities-services/PaymentMockService.ts";
import { MockChargingRulesService } from "services/mms/mock/entities-services/ChargingRuleMockService.ts";
import { MockRfidRuleService } from "./entities-services/RfidRuleMockService"
import { MockOrganizationService } from "services/mms/mock/entities-services/OrganizationMockService"

export class MockMmsService extends MmsService {
        constructor(delay: number = 300) {
                const communicationService = new CommunicationService(delay)
                const cardHolderService = new MockCardHolderService(communicationService)
                const stationsService = new MockStationsService(communicationService)
                const profileService = new MockProfileService(communicationService)
                const rfidService = new MockRfidService(communicationService)
                const invoiceService = new MockInvoiceService(communicationService)
                const paymentService = new MockPaymentService(communicationService)
                const sessionsService = new MockSessionsService(communicationService)
                const chargingRulesService = new MockChargingRulesService(communicationService)
                const rfidRuleService = new MockRfidRuleService(communicationService)
                const organizationService = new MockOrganizationService(communicationService)

            super({
                cardHolderService,
                stationsService,
                profileService,
                rfidService,
                invoiceService,
                paymentService,
                sessionsService,
                chargingRulesService,
                rfidRuleService,
                organizationService,
            })
        }
}
